import { Button, Modal, Card, Image, notification } from "antd";
import { getStore } from "../../utils/global";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import axios from "../../utils/axios";

const StampIMG = ({ data, refresh }) => {
  let img64 = `data:image/png;base64, ${data?.base64}`;

  const { confirm } = Modal;
  const { Meta } = Card;

  const deleteImage = async () => {
    const { kdss_user } = getStore("user");

    await axios.post(`/admin/api/user/deleteimg/${kdss_user}/${data?.id}`);

    refresh();

    notification.success({ message: "Deleted." });
  };

  return (
    <Card
      cover={<Image className="image-uploaded-list" src={img64} alt={data?.id} style={{ margin: 0 }} />}
      actions={[
        <Button
          type="outline"
          shape="circle"
          icon={<DeleteOutlined />}
          size="small"
          danger
          onClick={() => {
            confirm({
              title: "Are you sure to delete this?",
              icon: <ExclamationCircleOutlined />,
              content: data?.shortname,
              onOk() {
                deleteImage();
              },
            });
          }}
        />,
      ]}>
      <Meta
        title={data?.shortname}
        description={data?.desc}
        avatar={<img alt="type" src={`/${data?.type}.png`} width={20} />}
        style={{ alignItems: "center" }}
      />
    </Card>
  );
};

export default StampIMG;
